module.exports = __webpack_public_path__ + "img/font1.15385b5b.png";